import VideoSrc from 'builder/views/Interview/assets/interview-start-page-video.mp4'
import { InterviewStartBase } from '../InterviewStartBase/InterviewStartBase'
import { Right, Left, StyledVideo, Content, Row, VideoWrapper } from './styles'

export const StartContent = () => {
  return (
    <Content>
      <Row>
        <Left>
          <InterviewStartBase />
        </Left>
        <Right>
          <VideoWrapper>
            <StyledVideo src={VideoSrc} key={0} autoPlay muted loop playsInline />
          </VideoWrapper>
        </Right>
      </Row>
    </Content>
  )
}
